import React, { useState, useEffect } from 'react';
import { CheckCircle } from 'lucide-react';

const WishlistNotification: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [propertyId, setPropertyId] = useState<number | null>(null);
  
  useEffect(() => {
    const handleWishlistAdded = (event: Event) => {
      const customEvent = event as CustomEvent<{ propertyId: number }>;
      setPropertyId(customEvent.detail.propertyId);
      setVisible(true);
      
      // Hide notification after 3 seconds
      setTimeout(() => {
        setVisible(false);
      }, 3000);
    };
    
    document.addEventListener('wishlist:added', handleWishlistAdded);
    
    return () => {
      document.removeEventListener('wishlist:added', handleWishlistAdded);
    };
  }, []);
  
  return (
    <div 
      className={`
        fixed bottom-4 right-4 bg-black text-white p-4 rounded-lg shadow-lg z-50
        transform transition-all duration-500
        ${visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'}
      `}
    >
      <div className="flex items-center">
        <CheckCircle className="h-5 w-5 text-global-cyan mr-2" />
        <p>Immobilie zur Wunschliste hinzugefügt</p>
      </div>
    </div>
  );
};

export default WishlistNotification;
